export type AppEnv = 'develop' | 'stage' | 'production';

export const appEnv: AppEnv | undefined = import.meta.env.VITE_PUBLIC_APP_ENV;

export const isDev: boolean = appEnv === 'develop';
export const isStage: boolean = appEnv === 'stage';
export const isProd: boolean = appEnv === 'production';

export const isServiceMode: boolean = import.meta.env.VITE_PUBLIC_IS_SERVICE_MODE === 'true';

export const serviceModeDescription: string = import.meta.env.VITE_PUBLIC_SERVICE_MODE_DESC;

export const apiUrl: string | undefined = import.meta.env.VITE_PUBLIC_API_URL;
